/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `openai` - OPENAI
 * * `anthropic` - ANTHROPIC
 * * `google` - GOOGLE
 * * `xai` - XAI
 * * `meta` - META
 * * `amazon` - AMAZON
 * * `cohere` - COHERE
 */
export enum AiProvider {
  OPENAI = 'openai',
  ANTHROPIC = 'anthropic',
  GOOGLE = 'google',
  XAI = 'xai',
  META = 'meta',
  AMAZON = 'amazon',
  COHERE = 'cohere',
}
